import React, { useMemo } from 'react'
import { BiSolidUser } from 'react-icons/bi'
import sanitizeHtml from 'sanitize-html'
import Loader from '../../components/loader/Loader'

export interface IMessage {
	value: string
	agent: 'USER' | 'AI'
	responseId?: string
}

interface IProps {
	message: IMessage
	children?: React.ReactNode
}

function GHIcon() {
	return (
		<div className="h-10 w-10 bg-[#0091ea] rounded-full p-2">
			<img className="h-full w-full" src="/assets/icons/minimal.svg" alt="GHBranding" title="GHBranding" />
		</div>
	)
}

function UserIcon() {
	return (
		<div className="h-10 w-10 bg-white rounded-full p-2 flex justify-center items-center">
			<BiSolidUser size="1.5rem" className="fill-gray-700" />
		</div>
	)
}

export function LoadingMessage() {
	return (
		<ChatMessage
			message={{
				agent: 'AI',
				value: '',
			}}
		>
			<Loader />
		</ChatMessage>
	)
}

export function ErrorMessage() {
	return (
		<ChatMessage
			message={{
				agent: 'AI',
				value: '',
			}}
		>
			<div className="font-semibold text-red-500">Oops, parece que houve um problema, tente novamente mais tarde ou inicie um novo chat.</div>
		</ChatMessage>
	)
}

export default function ChatMessage(props: IProps) {
	const clean = sanitizeHtml(props.message.value, {
		allowedTags: ['b', 'i', 'em', 'strong', 'a'],
		allowedAttributes: {},
	}).replaceAll('\n', '<br/>')

	const MessageElement = useMemo(
		() => (
			<div className="flex flex-row w-full gap-4">
				<div className="shrink">{props.message.agent === 'AI' ? <GHIcon /> : <UserIcon />}</div>
				<div className="grow pt-1.5">{props.children ? props.children : <div dangerouslySetInnerHTML={{ __html: clean }}></div>}</div>
			</div>
		),
		[clean, props.children, props.message.agent]
	)

	return props.message.agent === 'AI' ? (
		<div className="bg-transparent p-2 rounded-md">{MessageElement}</div>
	) : (
		<div className="bg-white bg-opacity-60 bg-transparent p-2 rounded-md">{MessageElement}</div>
	)
}
